/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmImagesCreate } from "../../funcs/llmImagesCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateImageRequest$inboundSchema,
};

export const tool$llmImagesCreate: ToolDefinition<typeof args> = {
  name: "llm-images-create",
  description: `Generate images from text descriptions

Creates AI-generated images from text descriptions.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmImagesCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
